import React, { useState, useEffect } from "react";
import axios from "axios";

const API_URL = "https://orders.timhimmelsbach.com"; // Local FastAPI backend
const WS_URL =  "wss://orders.timhimmelsbach.com/ws" //window.location.protocol === "https:" ? "wss://209.38.244.204:8000/ws" : "ws://209.38.244.204:8000/ws";
export default function App() {
    const [token, setToken] = useState(localStorage.getItem("jwt") || "");
    const [orders, setOrders] = useState({ open: {}, completed: [] });
    const [socket, setSocket] = useState(null);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    useEffect(() => {
      if (token) {
          const ws = new WebSocket(`${WS_URL}?token=${token}`);
  
          ws.onopen = () => console.log("WebSocket connected");
          ws.onerror = (error) => console.error("WebSocket error", error);
          ws.onclose = (event) => console.log("WebSocket closed", event);
          ws.onmessage = (event) => {
              console.log(event.data);
              const newOrder = JSON.parse(event.data);
              setOrders(newOrder);
          };
  
          setSocket(ws);
          return () => ws.close();
      }
  }, [token]);

  //   useEffect(() => {
  //     if (token) {
  //         const ws = new WebSocket(WS_URL, token); // No array brackets
  
  //         ws.onopen = () => console.log("WebSocket connected");
  //         ws.onerror = (error) => console.error("WebSocket error", error);
  //         ws.onclose = (event) => console.log("WebSocket closed", event);
  //         ws.onmessage = (event) => {
  //             console.log(event.data);
  //             const newOrder = JSON.parse(event.data);
  //             setOrders(newOrder);
  //         };
  
  //         setSocket(ws);
  //         return () => ws.close();
  //     }
  // }, [token]);

  // useEffect(() => {
  //   const ws = new WebSocket(WS_URL, token); // Remove token

  //   ws.onopen = () => console.log("WebSocket connected");
  //   ws.onerror = (error) => console.error("WebSocket error", error);
  //   ws.onclose = (event) => console.log("WebSocket closed", event);
  //   ws.onmessage = (event) => {
  //       // print event data
  //       console.log(event.data);
  //       const newOrder = JSON.parse(event.data);
  //       setOrders(newOrder);
  //   };

  //   setSocket(ws);
  //   return () => ws.close();
  // }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${API_URL}/login`, { email, password });
            const jwt = response.data.token;
            localStorage.setItem("jwt", jwt);
            setToken(jwt);
        } catch (error) {
            alert("Login failed");
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("jwt");
        setToken("");
        setOrders({ open: {}, completed: [] });;
        if (socket) socket.close();
        window.location.reload();
    };

    const toggleItem = (itemId) => {
        if (socket && socket.readyState === WebSocket.OPEN) {
            const message = JSON.stringify({ toggle_item: itemId });
            console.log("Sending message:", message);
            socket.send(message);
        } else {
            console.error("WebSocket is not connected");
            alert("Not connected to the server");
        }
    };

    return (
      <div style={styles.container}>
        {!token ? (
          <div style={styles.loginBox}>
            <h2 style={styles.title}>Login</h2>
            <form onSubmit={handleLogin} style={styles.form}>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={styles.input}
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={styles.input}
              />
              <button type="submit" style={styles.button}>Login</button>
            </form>
          </div>
        ) : (
          <div style={styles.orderContainer}>
            <button onClick={handleLogout} style={styles.logoutButton}>Logout</button>
            <div style={styles.orders}>
              {Object.entries({...orders.open, "Fertiggestellt": orders.completed}).map(([category, items]) => (
                <div key={category} style={styles.orderGroup}>
                  <h4 style={styles.orderTitle}>{category}</h4>
                  <ul style={styles.orderList}>
                    {items.map((item) => (
                      <li key={item.id} style={styles.orderItem} onClick={() => toggleItem(item.id)}>
                        <span
                          style={{
                            ...styles.priorityCircle,
                            backgroundColor: item.priorityColor,
                          }}
                        >
                          {item.priority}
                        </span>{" "}
                        {item.amount} {item.name}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
}

const styles = {
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#121212",
        color: "#ffffff",
    },
    loginBox: {
        background: "#1e1e1e",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0px 0px 10px rgba(255, 255, 255, 0.1)",
        textAlign: "center",
        width: "300px",
    },
    title: {
        marginBottom: "15px",
        color: "#ffffff",
    },
    form: {
        display: "flex",
        flexDirection: "column",
    },
    input: {
        padding: "10px",
        marginBottom: "10px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        fontSize: "16px",
        backgroundColor: "#333333",
        color: "#ffffff",
    },
    button: {
        padding: "10px",
        backgroundColor: "#007BFF",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "16px",
    },
    orderContainer: {
        textAlign: "right",
        width: "90%",
    },
    logoutButton: {
        padding: "10px",
        marginBottom: "20px",
        backgroundColor: "#dc3545",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "16px",
    },
    orders: {
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        textAlign: "left",
        maxHeight: "80vh", // Set a maximum height for the orders container
        overflowY: "auto", // Enable vertical scrolling
        wordSpacing: "40px",
    },
    orderGroup: {
        margin: "0px 0", // Reduced vertical space between order groups
        padding: "0px",
        width: "100%",
    },
    orderTitle: {
        margin: "10px 0",
        color: "#ffffff",
    },
    orderList: {
        listStyle: "none",
        padding: 0,
    },
    orderItem: {
        background: "#1e1e1e",
        margin: "5px 0",
        padding: "10px",
        borderRadius: "5px",
        cursor: "pointer",
        color: "#ffffff",
    },
    priorityCircle: {
        display: "inline-block",
        width: "24px",
        height: "24px",
        lineHeight: "24px",
        borderRadius: "50%",
        color: "black",
        textAlign: "center",
        marginRight: "10px",
    },
};
